import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col bg-[#0a3d5e] text-slate-100">
      <Navbar />
      <main key={location.pathname} className="flex-1 page-in">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
